import { createSelector } from 'reselect';

const selectCancelFundingSearchMatch = (state) =>
  state.getIn(['fundingSearch', 'cancelFundingSearchMatch']);

const selectMatchFromFundingSearch = (state, { fundingSearchId, fundingMatchId }) =>
  state
    .getIn(['fundingSearch', 'byId', fundingSearchId, 'matches'], [])
    .find((match) => match.id === fundingMatchId);

const selectMatchIgnoreStatuses = (state, matchId) =>
  state.getIn(['fundingSearch', 'matchIgnoredStatuses', matchId], []);

const makeSelectCancelFundingSearchMatchModalState = () =>
  createSelector(selectCancelFundingSearchMatch, (state) => state.get('modalOpen'));

const makeSelectCancelFundingSearchMatchHasError = () =>
  createSelector(selectCancelFundingSearchMatch, (state) => state.getIn(['network', 'error']));

const makeSelectCancelFundingSearchMatchIsLoading = () =>
  createSelector(selectCancelFundingSearchMatch, (state) => state.getIn(['network', 'loading']));

const makeSelectFundingSearchMatchToCancel = () =>
  createSelector(selectCancelFundingSearchMatch, (state) => state.get('match'));

export {
  makeSelectCancelFundingSearchMatchHasError,
  makeSelectCancelFundingSearchMatchIsLoading,
  makeSelectCancelFundingSearchMatchModalState,
  makeSelectFundingSearchMatchToCancel,
  selectMatchIgnoreStatuses,
  selectMatchFromFundingSearch,
};
